import React from 'react';
import useCoupon from 'hooks/useCoupon';
import useCustomer from 'hooks/useCustomer';

import styles from './ContactMessage.module.scss';

const ContactMessage: React.FC = () => {
  const { coupon } = useCoupon();
  const { isTrialCustomer, isExistingCustomer, isAgencyCustomer } = useCustomer();

  let message = '今すぐダウンロード！';
  if (coupon) {
    message = '今だけ特別!! 10%OFFでご案内';
  } else if (isTrialCustomer) {
    message = 'まずは30日間お試し！';
  } else if (isExistingCustomer || isAgencyCustomer) {
    message = '些細なことでもお気軽に！';
  }
  message = 'お問合せは営業担当、または下記フリーダイヤルまで';

  return <p className={styles.message}>{message}</p>;
};

export default ContactMessage;
